import React, { useRef, useState } from "react";

// Img
import eventbanner from "../../assets/png/event-banner.png";
import icPhoto from "../../assets/svg/action/ic-photo.svg";
import icEditPen from "../../assets/svg/action/ic-edit-pen.svg";
import icRemove from "../../assets/svg/action/ic-remove.svg";

// css
import classes from "./EventBanner.module.css";
import "./EventBanner.css";

// Jds
import {
  ListBlock,
  Text,
  Icon,
  Container,
  Button,
  DropdownMenuGroup,
  DropdownMenuItem,
  ActionButton,
  Notifications,
} from "@jds/core";

// Mui
import { Box, Divider, Stack } from "@mui/material";

// Local
import EventTypeBadge from "./Badges/EventTypeBadge";

import KebabCircleButton from "./Buttons/KebabCircleButton";
import MuiMenu from "./MuiMenu";
import MenuItem from "./Views/MenuItem";
import JdsModal from "./JdsModal";
import JdsMenu from "./JdsMenu";
import CancelEventForm from "./Form/CancelEventForm";
import EditEventForm from "./Form/EditEventForm";
import {
  baseToImg,
  imgValidationCheck,
  validateFileSignature,
} from "../../util/helper";
import EmptyState from "../NoData/EmptyState";
import decryptUrl from "../../util/img-decryption";
import FrameModal from "./FrameModal/FrameModal";
import CreateWatermark from "./Form/CreateWatermark";

const PhotoFrameMenu = (props) => (
  <MenuItem src={icPhoto} label="Photo Frame" {...props} />
);

const EditEventMenu = (props) => (
  <MenuItem src={icEditPen} label="Edit Event" {...props} />
);

const CancelEventMenu = (props) => (
  <MenuItem src={icRemove} label="Cancel Event" {...props} />
);

export default function EventBanner(props) {
  const menuButtonRef = useRef();
  const { bannerUpdate } = props;
  const {
    bannerImage,
    eventDate,
    eventTime,
    eventDetails,
    watermarkModalOpen,
  } = props;
  const [isEditEventModal, setEditEventModal] = useState(true);
  const [isCancelEventModal, setCancelEventModal] = useState(true);
  const [isPhotoBannerModal, setPhotoBannerModal] = useState(true);
  const [isWatermarkModalClose, setWatermarkModalClose] = useState(
    watermarkModalOpen ? false : true,
  );
  const fileInputRef = useRef(null);
  const isAdmin = eventDetails?.userRole == "ADMIN";

  const inputHandle = (e) => {
    const formData = new FormData();
    formData.append("bannerimage", e.target.files[0]);
    // formData.append("description", props.eventDescription || "");
    formData.append("id", props.eventId);
    bannerUpdate(
      {
        url: "event/update-banner-image",
        method: "PATCH",
        formData: true,
        body: formData,
      },
      (data) => {
        props?.eventRecall();
      },
    );
  };

  return (
    <Box
      width="100%"
      // height={211}
      height={"35.22vh"}
      className={classes["event-banner"]}
      borderRadius={6}
    >
      <div className={classes.overlay}></div>
      {/* <img
          // src={bannerImage ? bannerImage : eventbanner}
          src={bannerImage ? decryptUrl(bannerImage) : eventbanner}
          alt="banner of the event"
          className={classes["event-banner__img"]}
        /> */}

      {bannerImage ? (
        <img
          src={bannerImage ? decryptUrl(bannerImage) : ""}
          alt="banner of the event"
          className={classes["event-banner__img"]}
        />
      ) : (
        <div className={classes["loader_container"]}>
          <div className={classes["loader"]}></div>
        </div>
      )}
      <EventTypeBadge
        className={classes["event-banner__badge"]}
        label={eventDetails?.eventTypeName}
        // src={
        //   eventDetails?.eventTypeIcon
        //     ? baseToImg(eventDetails?.eventTypeIcon)
        //     : ""
        // }
        src={
          eventDetails?.eventTypeIcon
            ? decryptUrl(eventDetails?.eventTypeIcon)
            : ""
        }
      />
      {eventDetails?.startDate === eventDetails?.endDate ? (
        <Stack
          direction={"row"}
          alignItems="center"
          divider={
            <Divider
              orientation="vertical"
              flexItem
              sx={{ width: "unset", height: "18px", alignSelf: "center" }}
            />
          }
          spacing={1}
          className={classes["event-banner__date-time"]}
        >
          <Text text={eventDate} color="primary_grey_40" />

          {eventDetails?.startDate === eventDetails?.endDate ? (
            <Text text={eventTime} color="primary_grey_40" />
          ) : (
            <Text text={eventDetails?.endDate} color="primary_grey_40" />
          )}

          {/* <Text text={eventTime} color="primary_grey_40" /> */}
        </Stack>
      ) : (
        <Stack
          direction={"row"}
          alignItems="center"
          spacing={1}
          className={classes["event-banner__date-time"]}
        >
          <Text
            className="event-date-time-style"
            text={`${eventDate} to ${eventDetails?.endDate}`}
            color="primary_grey_40"
          />
        </Stack>
      )}

      <Box className={classes["event-banner__action-button-container"]}>
        {/* <MenuButton
          anchorRef={menuButtonRef}
          items={[
            {
              type: "heading",
              label: "Fruits",
            },
          ]}
          trigger={{
            component: KebabCircleButton,
            props: {
              className: classes["event-banner__action-button"],
            },
          }}
        >
          <Box width={120} height={90} bgcolor={"var(--color-primary-60)"}>
            <Text text="fruits" />
          </Box>
        </MenuButton> */}

        {/* <MuiMenu
          trigger={{
            component: KebabCircleButton,
            props: {
              className: classes["event-banner__action-button"],
            },
          }}
          anchorOrigin={{
            vertical: "bottom",
            horizontal: "right",
          }}
          transformOrigin={{
            vertical: "top",
            horizontal: "right",
          }}
          sx={{ width: "234px" }}
        >
          <JdsModal
            header="Add Photo Frame"
            trigger={{ component: PhotoFrameMenu }}
          ></JdsModal>
          <MenuItem
            src={icEditPen}
            label="Edit Event"
            onClick={() => {
              setEditEventModal(false);
            }}
          />

          <JdsModal
            header="Edit Event"
            close={isEditEventModal}
            onClose={() => {
              setEditEventModal(true);
            }}
          >
            {!isEditEventModal && (
              <EditEventForm
                eventDetails={eventDetails}
                eventRecall={props.eventRecall}
              />
            )}
          </JdsModal>

          <JdsModal
            header="Cancel Event"
            trigger={{ component: CancelEventMenu }}
            size="m"
          >
            <CancelEventForm />
          </JdsModal>
        </MuiMenu> */}

        {isAdmin && (
          <JdsMenu
            trigger={{
              component: KebabCircleButton,
            }}
          >
            <DropdownMenuGroup hideBottomDivider>
              {eventDetails?.frameStatus &&
                eventDetails?.userRole === "ADMIN" && (
                  <DropdownMenuItem
                    prefix={"IcPhoto"}
                    label="Photo Frame"
                    value="photoFrame"
                    onClick={() => setPhotoBannerModal(false)}
                  />
                )}
              {/* <DropdownMenuItem
                prefix={"IcWater"}
                label="Watermark"
                value="watermark"
                onClick={() => setWatermarkModalClose(false)}
              /> */}
              <DropdownMenuItem
                prefix={"IcEditPen"}
                label="Edit Event"
                value="editEvent"
                onClick={() => {
                  setEditEventModal(false);
                }}
              />
              <DropdownMenuItem
                prefix={"IcError"}
                label="Cancel Event"
                value="cancelEvent"
                onClick={() => setCancelEventModal(false)}
              />
            </DropdownMenuGroup>
          </JdsMenu>
        )}

        <JdsModal
          header="Add Photo Frame"
          close={isPhotoBannerModal}
          onClose={() => {
            setPhotoBannerModal(true);
          }}
        >
          {!isPhotoBannerModal && <FrameModal />}
        </JdsModal>

        <JdsModal
          header="Add Watermark"
          close={isWatermarkModalClose}
          onClose={() => {
            setWatermarkModalClose(true);
          }}
        >
          {!isWatermarkModalClose && (
            <CreateWatermark onCancel={() => setWatermarkModalClose(true)} />
          )}
        </JdsModal>

        <JdsModal
          header="Edit Event"
          close={isEditEventModal}
          onClose={() => {
            setEditEventModal(true);
          }}
        >
          {!isEditEventModal && (
            <EditEventForm
              eventDetails={eventDetails}
              eventRecall={props.eventRecall}
            />
          )}
        </JdsModal>

        <JdsModal
          header="Cancel Event"
          size="m"
          close={isCancelEventModal}
          onClose={() => {
            setCancelEventModal(true);
          }}
        >
          {!isCancelEventModal && <CancelEventForm />}
        </JdsModal>

        {/* <MenuButton trigger={{ component: KebabButton }}>
          <DropdownMenuGroup hideBottomDivider>
            <Container direction="row" gap={12}>
              <DropdownMenuItem
                prefix={"IcEditPen"}
                label="Edit"
                value="edit"
              />
            </Container>
            <DropdownMenuItem
              prefix={"IcTrash"}
              label="Delete"
              value="delete"
              // onClick={() => setDeleteModalClose(false)}
            />
            <DropdownMenuItem prefix={"IcShare"} label="Share" value="share" />
          </DropdownMenuGroup>
        </MenuButton> */}
      </Box>
      <Stack
        direction={"row"}
        alignItems="center"
        spacing={1}
        className={classes["event-banner__upload"]}
      >
        {isAdmin && (
          <>
            <input
              type="file"
              accept=".png, .jpg, .jpeg"
              id="banner-file__upload"
              onChange={(e) => {
                const file = e.target.files[0];
                if (imgValidationCheck(e)) {
                  validateFileSignature(file, {
                    jpeg: ["ffd8ffe0", "ffd8ffe1", "ffd8ffe2", "ffd8ffdb"], // JPEG signatures can vary
                    png: ["89504e47"],
                  })
                    .then((isValid) => {
                      if (isValid) {
                        console.log("okokoksucces");

                        inputHandle(e);
                      } else {
                        Notifications.toast.error({
                          id: "event-banner-update-img",
                          title:
                            "Please upload a valid image file (JPG, JPEG and PNG).",
                        });
                      }
                    })
                    .catch((error) => {
                      Notifications.toast.error({
                        id: "event-banner-update-img",
                        title:
                          "Please upload a valid image file (JPG, JPEG and PNG).",
                      });
                    });
                } else {
                  Notifications.toast.error({
                    id: "event-banner-update-img",
                    title:
                      "Please upload a valid image file (JPG, JPEG and PNG).",
                  });
                }
              }}
              ref={fileInputRef}
            />
            <div
              className={classes["upload-banner-btn"]}
              onClick={() => {
                console.log("okok");

                fileInputRef.current.click();
              }}
            >
              <Icon ic="IcUpload" />
              <span className={classes["upload-text"]}>Upload Banner</span>
            </div>
          </>
        )}
        {!isAdmin && (
          <div style={{ display: "flex", gap: "8px", alignItems: "center" }}>
            <Icon
              ic="IcUser"
              kind="background-bold"
              color="grey-60"
              size="large"
            />
            <Text
              text={localStorage.eventOrganizerName + " (Organizer)"}
              color="primary_grey_40"
            />
          </div>
        )}
      </Stack>
    </Box>
  );
}
